import getHotelStaticUrl from '@stencil/hotels-utils/src/get-hotel-static-url';
import {get} from '@stencil/megatron';

export default async function fetchHotelsDetailsStaticData({vhid, destination, filter, flavour}) {
  const url = getHotelStaticUrl({
    vhid: vhid || destination._id,
    filter,
    flavour,
  });
  return await get(url, {name: 'details static'});
}
